<!-- src/components/WeeklyCalendar.vue -->

<template>
  <div class="week-calendar">
    <div class="calendar-header">
      <button @click="prevWeek">上一周</button>
      <span>{{ formatDate(currentWeekStart) }} - {{ formatDate(currentWeekEnd) }}</span>
      <button @click="nextWeek">下一周</button>
    </div>
    <div class="calendar-week-header">
      <div class="week-day" v-for="(day, index) in weekHeaders" :key="index">
        {{ day }}
      </div>
    </div>
    <div class="calendar-body">
      <div v-for="(day, index) in weekDays" :key="index" class="day">
        <div class="date">{{ day }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentWeekStart: this.getStartOfWeek(new Date())
    };
  },
  computed: {
    currentWeekEnd() {
      return new Date(this.currentWeekStart.getTime() + 6 * 24 * 60 * 60 * 1000);
    },
    weekDays() {
      let days = [];
      for (let i = 0; i < 7; i++) {
        let day = new Date(this.currentWeekStart);
        day.setDate(day.getDate() + i);
        days.push(this.formatDate(day));
      }
      return days;
    },
    weekHeaders() {
      return ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    }
  },
  methods: {
    getStartOfWeek(date) {
      let day = date.getDay();
      let diff = date.getDate() - day; // Sunday as the first day of the week
      return new Date(date.setDate(diff));
    },
    formatDate(date) {
      let d = new Date(date);
      let month = '' + (d.getMonth() + 1);
      let day = '' + d.getDate();
      let year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      return [year, month, day].join('-');
    },
    prevWeek() {
      this.currentWeekStart.setDate(this.currentWeekStart.getDate() - 7);
      this.currentWeekStart = new Date(this.currentWeekStart);
    },
    nextWeek() {
      this.currentWeekStart.setDate(this.currentWeekStart.getDate() + 7);
      this.currentWeekStart = new Date(this.currentWeekStart);
    }
  }
};
</script>


<style scoped>
.week-calendar {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  width: 300px;
  margin-bottom: 10px;
}

.calendar-week-header {
  display: flex;
  justify-content: space-between;
  width: 100%;
  background-color: #f0f0f0;
  padding: 10px 0;
}

.week-day {
  flex: 1;
  text-align: center;
  font-weight: bold;
}

.calendar-body {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.day {
  flex: 1;
  text-align: center;
}

.date {
  padding: 10px;
  border: 1px solid #ccc;
}
</style>
